import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function AddObituaryModal({ onClose, onSubmit, members }) {
  const [formData, setFormData] = useState({
    member_id: '',
    content: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.member_id || !formData.content.trim()) return;
    onSubmit(formData);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="add-obituary-modal">
      <div className="bg-white rounded-lg shadow-floating max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-paper border-b border-border p-6 flex justify-between items-center">
          <h2 className="text-2xl font-serif text-foreground">Write Obituary</h2>
          <button onClick={onClose} className="text-foreground-muted hover:text-primary" data-testid="close-modal-btn">
            <X className="w-6 h-6" strokeWidth={1.5} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <Label htmlFor="member_id" className="font-sans text-foreground mb-2 block">Family Member *</Label>
            <Select value={formData.member_id} onValueChange={(value) => setFormData({ ...formData, member_id: value })}>
              <SelectTrigger data-testid="member-select" className="bg-transparent border-b-2 border-border focus:border-primary rounded-none px-0 py-2 font-sans">
                <SelectValue placeholder="Select a member" />
              </SelectTrigger>
              <SelectContent className="bg-white border border-border shadow-floating">
                {members.map(member => (
                  <SelectItem key={member.member_id} value={member.member_id}>
                    {member.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="content" className="font-sans text-foreground mb-2 block">Obituary Content *</Label>
            <Textarea
              id="content"
              data-testid="obituary-content-input"
              value={formData.content}
              onChange={(e) => setFormData({ ...formData, content: e.target.value })}
              className="bg-transparent border border-border focus:border-primary rounded-lg p-3 font-sans min-h-[200px]"
              placeholder="Write a heartfelt tribute..."
              required
            />
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              data-testid="cancel-btn"
              className="border-2 border-primary/20 text-primary hover:bg-primary/5 rounded-full px-6 py-2 font-serif tracking-wide"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              data-testid="submit-obituary-btn"
              className="bg-primary text-primary-foreground hover:bg-primary-hover rounded-full px-6 py-2 font-serif tracking-wide"
            >
              Create Obituary
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}